export default __webpack_public_path__ + "static/850-4c0f377880c8b30bfdbdf01189cc94de.gif";